import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { api } from "../api";

const titles: Record<string, string> = { "/": "角色入口", "/student": "学生首页", "/teacher": "教师工作台", "/knowledge": "知识图谱", "/cases": "案例库", "/projects": "项目工作台" };

export function PageAnalytics() {
  const location = useLocation();
  useEffect(() => {
    void api.recordEvent({ event_type: "page_view", resource_type: "page", resource_id: location.pathname, resource_title: titles[location.pathname] || location.pathname, value: "" }).catch(() => undefined);
  }, [location.pathname]);
  return null;
}
